import listActions from 'src/modules/outcome/list/outcomeListActions';
import OutcomeService from 'src/modules/outcome/outcomeService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'OUTCOME_DESTROY';

const outcomeDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: outcomeDestroyActions.DESTROY_STARTED,
      });

      await OutcomeService.destroyAll([id]);

      dispatch({
        type: outcomeDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.outcome.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/outcome');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: outcomeDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: outcomeDestroyActions.DESTROY_ALL_STARTED,
      });

      await OutcomeService.destroyAll(ids);

      dispatch({
        type: outcomeDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.outcome.destroyAll.success'),
      );

      getHistory().push('/outcome');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: outcomeDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default outcomeDestroyActions;
